import { render, staticRenderFns } from "./ServidorSelect.vue?vue&type=template&id=581e7bf6"
import script from "./ServidorSelect.vue?vue&type=script&lang=js"
export * from "./ServidorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports